import '../incubator/incubator.css';
import Plus from '../../../images/Plus.svg';
import Minus from '../../../images/Minus.svg';
import React, { useEffect, useState } from 'react';
import pdf from '../../../images/PDF.svg';
import xls from '../../../images/xls.svg';
import doc from '../../../images/doc.svg';
import xlsx from '../../../images/xls.svg';
import Allround from '../../../images/Allround.svg';
import TrancheStepperComponent from './TrancheStepperComponent';
import Stepper from 'bs-stepper';
import 'bs-stepper/dist/css/bs-stepper.min.css';
import {
  AddTranche,
  Documents,
  TrancheDetail,
} from '../../../models/funddetails/TrancheDetails';
import {
  ADD_MORE_TRANCHE,
  ADD_TRANCHE_WITH_Re_AMOUNT,
  GET_ALL_TRANCHES,
  GET_BANK_DETAILS,
  GET_TRANCHE_REQUEST,
  NODE_URL,
  QUICK_EDIT,
  QUICK_Re_EDIT,
  // sec_re_updateTranche
} from '../../../constants/api';
import { get, post } from '../../../effects/api/api.common';
import TrancheInfoReapplyComponent from '../../incubator/common/TrancheInfoReapplyComponent';
import TrancheWiseReapplyDetails from '../../incubator/common/TrancheWiseReapplyDetails';
import { UploadTypeEnum } from '../../../utils/Enums';
import { changeNumberFormat, createFile } from '../../../utils/CommonMethods';
import { FileDownloadModel } from './ApplicationGeneralDetails';
import AccountDetailsComponent from '../../incubator/dashboard/AccountDetailsComponent';
import { AccountDetailsData } from '../../../models/funddetails/AccountDetailsData';
import { getSessionStorageValue } from '../../../effects/utils/session-storage';

import { useHistory } from "react-router-dom";

interface IFundDetailsProps {
  application_id: number;
  total_grant_approved: number;
  trancheData: any;
  trancheDataASC: any;
  accountDetailsData: AccountDetailsData;
  application_status:string;
  total_grant_disbursed:number;
  totalManagementAmount:number;
  incubator_application_no:any;
  
 
}

function IncubatorFundDetailsReapplyComponent(props: IFundDetailsProps) {
  const {
    application_id,
    total_grant_approved,
    trancheData,
    trancheDataASC,
    accountDetailsData,
    application_status,
    total_grant_disbursed,
    totalManagementAmount,
    incubator_application_no


  } = props;

  // console.log("***********",applicationGeneralDetailModel);
  const [isTrancheStepper, setStepper] = useState<boolean>(true);
  const [isEditing, setIsEditing] = useState(false);
  const [activeIndex, setActiveIndex] = useState('');
  const changeActive = (id: string) => {
    setActiveIndex(id);
  };
  const changeActiveBack = () => {
    setActiveIndex('');
  };
  const [loggedInRole, setLoggedInRole] = useState('');
  const history = useHistory();
  // const [bank,setBank]=useState('')
  const [total_grand_approved_amount, setGrantApproved] = useState("");
  const [total_Management_approved_amount, setManagementAmount] = useState("");
  const [isReadonly, setIsReadonly] = useState(true);
  useEffect(() => {
   
    setStepper(true);
    const user: any = getSessionStorageValue("user");
    const userInfo = JSON.parse(user)
    setLoggedInRole(userInfo.roles);
    // getAccountDetails();
    // console.log("**************")
    
    setGrantApproved(total_grant_approved == null ? "0" : total_grant_approved.toString());
    setManagementAmount(totalManagementAmount==null?"0": totalManagementAmount.toString())
    // console.log(props.application_id,"82")
  }, [total_grant_approved,accountDetailsData]);
   
  useEffect(()=>{
    // console.log("total managment",total_Management_approved_amount)
      
  },[total_grand_approved_amount,accountDetailsData])

  const [addMoreTrancheData, setAddMoreTrancheData] = useState<AddTranche>(
    new AddTranche(0, '', 0, 0)
  );
  const [isAddTrancheRowVisible, setIsAddTrancheRowVisible] = useState(true);

  const [showEditSuccessModal, setShowSuccessModal] = useState(false);
  const [showEditFailureModal, setShowFailureModal] = useState(false);
  const dismissModal = () => {
    setShowSuccessModal(false);
  
    history.push('/secretariat_incubator_list')
    window.location.reload()
    setShowFailureModal(false);

  };

  const addMoreTranche = () => {

    // let sum = 0;
    // trancheData.map((data:any)=>{
    //   sum += Number(data.approved_amount);
    //   console.log(sum,"sum")
    // })
    let addTranche = JSON.parse(JSON.stringify(addMoreTrancheData));
    // console.log(addTranche,"106")
    addTranche['application_id'] = application_id;
    // console.log(addTranche)
    setAddMoreTrancheData(addTranche);

    setIsAddTrancheRowVisible(false);
    const user: any = getSessionStorageValue("user");
    const userInfo = JSON.parse(user)    
    const userId = userInfo.id
    let addMoreTrancheDetails = {
      application_id: application_id,
      approved_amount: addMoreTrancheData.amount_approved,
      logged_user_id:userId
    };
  //  console.log(addMoreTrancheDetails,"115")
    post(`${ADD_TRANCHE_WITH_Re_AMOUNT}`, addMoreTrancheDetails).then(
      (response: any) => {
        if (!response || !response.data) return;
        if (response.data.result == 'success') {
          setShowSuccessModal(true);
         
        } 
        else {
          setShowFailureModal(true);
        }
        //console.log(addMoreTrancheData, 'setaddMoreTrancheData');
        // getAllTranches();
      }
    );
  };
  const cancel = () => { };

  

  const handleChange = (
    evt: React.ChangeEvent<
      HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement
    >
  ) => {
    const name = evt.target.name;
    const value = evt.target.value;

    let trancheDetails = JSON.parse(JSON.stringify(trancheData));
    if (name == "amount_approved") {

      const numStr = String(evt.target.value);
      var count = 0;
      if (numStr.includes('.')) {
        count = numStr.split('.')[1].length;
      };
      if (count > 2) {
        trancheDetails[name] = Number(evt.target.value).toFixed(2);
      }
      else { trancheDetails[name] = evt.target.value; }

    }
    else {
      trancheDetails[name] = evt.target.value;
    }

    setAddMoreTrancheData(trancheDetails);
  };

  const handleInputChange = (
    evt: React.ChangeEvent<
      HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement
    >,
    index: number
  ) => {
    const name = evt.target.name;
    const value = evt.target.value;

    if(name === "item.approved_amount"){
       
    }
  };
 
  const handleChangeTotalGrantApproved = (evt: React.ChangeEvent<
    HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement
  >) => {
    const name = evt.target.name;
    const value = evt.target.value;

    let quickEdit = JSON.parse(JSON.stringify(quickEditPopupData));

    const numStr = String(evt.target.value);
    var count = 0;
    if (numStr.includes('.')) {
      count = numStr.split('.')[1].length;
    };
    if (count > 2) {
      quickEdit[name] = Number(evt.target.value).toFixed(2);
    }
    else { quickEdit[name] = evt.target.value; }

    //quickEdit["total_approved_amt"] = value;
    setQuickEditPopupData(quickEdit);
  }

  const formatDate = (date: string) => {
    var month = new Array();
    month[0] = 'Jan';
    month[1] = 'Feb';
    month[2] = 'Mar';
    month[3] = 'April';
    month[4] = 'May';
    month[5] = 'Jun';
    month[6] = 'Jul';
    month[7] = 'Aug';
    month[8] = 'Sep';
    month[9] = 'Oct';
    month[10] = 'Nov';
    month[11] = 'Dec';

    var d = new Date(date),
      monthn = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (monthn.length < 2) monthn = '0' + monthn;
    if (day.length < 2) day = '0' + day;

    return [day, month[d.getMonth()], year].join(' ');
  };

  const [quickEditPopupData, setQuickEditPopupData] = useState({ application_id: "", total_approved_amt: "", application_status: "",incubator_application_no:"" });
  const updateTotalGrantApproved = () => {
    const user: any = getSessionStorageValue("user");
    const userInfo = JSON.parse(user)    
    const userId = userInfo
    var payload = {
      application_id: application_id,
      total_approved_amt: quickEditPopupData.total_approved_amt,
      application_status: "7",  
      // incubator_application_no: incubator_application_no,  
      // user_role:userId.roles,  
      // logged_user_id:userId.id
    }

    post(QUICK_Re_EDIT, payload).then((response: any) => {
      // console.log("hii")
      if (!response || !response.data) return;
      // console.log(response.data.data[0].total_management_amount,"srii")


      if (response.data.result == "success") {
        // console.log(response.data)
        setGrantApproved(quickEditPopupData.total_approved_amt);
        setManagementAmount(response.data.data[0].total_management_amount.toString())
        // setManagementAmount(amountMangement)
    // history.push('/secretariat_view_application')
    // window.location.reload()
         
        
      }
      else {

      }
      // console.log(response.data)
    });
  }

  const setQuickEdit = (value: string) => {
    let quickEdit = JSON.parse(JSON.stringify(quickEditPopupData));
    // quickEdit["total_approved_amt"] = Number(value).toFixed();
    quickEdit["total_approved_amt"] = Number(value);
    
    setQuickEditPopupData(quickEdit);

  }



  const getFileDetails = (file: any, key: string) => {
    // console.log(file,"file_ext1")

    let file_name = '';
    let file_ext = '';
    file_name =
      file != undefined && file.length > 1
        ? file.substr(file.lastIndexOf('/') + 1, file.length)
        : '';

    file_ext = file != undefined && file.length > 1
      ? file.substr(
        file.lastIndexOf('.') + 1,
        file.length
      ) : "";
    if (key == 'ext') return file_ext;
    if (key == 'name') return file_name;
    if (key == 'file') return file != undefined ? file.toString() : '';
  };

  const downloadDocument = (file: any, file_name: any) => {
    fetch(file).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = file_name;
        a.click();
      });
      //window.location.href = response.url;
    });
  };


  return (
    <div className="container">
      <div className="row">
    {/* {console.log(props,"FundDetails")} */}
        
        <div className="col-md-3 left-align" style={{maxWidth:'20%'}}>
          <span className="fund-amount-cur">
            &#8377;
            <label className="fund-amount-label-value">
              {' '}
              {total_grand_approved_amount != null && total_grand_approved_amount != "0"
                ? changeNumberFormat(Number(total_grand_approved_amount), 2, 1)
                : 0}
            </label>
            {/* Cr */}
          </span>
          <br />
          <span className="fund-amount-label">Total Grant Approved</span>
          <br />
          {(application_status == "Selected" && loggedInRole != "eac")
            ?
            <a className="incubator-details-link"
              data-target="#editTotalGrantApproved"
              data-toggle="modal"
              onClick={() => setQuickEdit(total_grand_approved_amount.toString())}
            >Edit</a>

            :
            ""}

        </div>
        <div className="vl vl-mr"></div>
        <div className="col-md-3 left-align" style={{maxWidth:'20%'}}>
          <span className="fund-amount-cur">
            &#8377;
            <label className="fund-amount-label-value">
              {/* {console.log(total_Management_approved_amount,"336")} */}
              {' '}
              {total_Management_approved_amount !== null && total_Management_approved_amount !=="0"
                ? changeNumberFormat(Number(total_Management_approved_amount), 2, 1)
                : 0}
            </label>
            {/* Cr */}
          </span>
          <br />
          <span className="fund-amount-label">Total Management <br/>Fees</span>
          <br />
        </div>






        <div className="vl vl-mr"></div>
        <div className="col-md-3 left-align" style={{maxWidth:'20%'}}>
          <span className="fund-amount-cur">
            <label className="fund-amount-label-value">
              {trancheData.length}{' '}
            </label>
          </span>
          <br />

          <span className="fund-amount-label">Total No. of Tranches</span>
          <br />
          {loggedInRole != "eac" && <a
            className="incubator-details-link"
            data-target="#addMoreTranchePopUp"
            data-toggle="modal"
          >
            Add More Tranche
          </a>}
        </div>

        <div className="vl vl-mr"></div>
        <div className="col-md-3 " style={{maxWidth:'20%'}}>
          <span className="fund-amount-cur">
            &#8377;
            <label className="fund-amount-label-value">
              {' '}
              {total_grant_disbursed != null ? changeNumberFormat(Number(total_grant_disbursed.toString()), 2, 1) : 0}{' '}
            </label>

          </span>
          <br />
          <span className="fund-amount-label">
            Total Funds Disbursed to Incubator
          </span>
          <br />
          <a
            className="incubator-details-link"
            data-target="#viewBankDetails"
            data-toggle="modal"
          >
            View Bank Details
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col-md-9">
          <TrancheInfoReapplyComponent trancheDetailsModel={trancheDataASC} />
        </div>
      </div>

      <div className="row ">
        <div className="col-md-12 left-align">
          <span className="eac-heading-title">No. of Tranches</span>
        </div>
      </div>
      <div className="application-incubator-hr">
        <hr />
      </div>

      <div className="row">
        
        <div className="col-md-12">
          <TrancheWiseReapplyDetails trancheDetailsModel={trancheData} total_grant_approved={total_grant_approved} />
        </div>
      </div>

      {/* Total Grant Approved Edit pop up */}
      <div
        className="modal fade"
        id="editTotalGrantApproved"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-md"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header modal-header-border-none">
              <h5 className="modal-title " id="exampleModalLongTitle">
                Update Total Grant Approved <span className="eac-name-pop-up"></span>
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12 text-left">
                  <span className="col-form-head">Total Grant Approved</span>
                </div>
              </div>
              <div className="row mt-1-5">
                <div className="col-md-12 text-left">
                  <input
                    type="number"
                    className="form-control"
                    name="total_approved_amt"
                    value={quickEditPopupData.total_approved_amt}
                    placeholder="Enter total grant approved"
                    onChange={handleChangeTotalGrantApproved}
                  ></input>

                </div>
              </div>

              <div className="row">
                <div className="col-md-12 text-right">
                  <div className="btn-group mt-1-5 ">
                    <button
                      className="tertiary   btn-transparent-primary"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>

                    <button
                      type="button"
                      className="btn btn-sisfs btn-yellow-primary ml-2"
                      onClick={() => updateTotalGrantApproved()}
                      data-dismiss="modal"
                    >
                      Update{' '}
                    </button>
                  </div>
                </div>
              </div>

              <div className="row pt-3 mb-3">
                <div className="col-md-12 centerText"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* //Add more tranche */}

      <div
        className="modal fade"
        id="addMoreTranchePopUp"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header modal-header-border-none ml-18px">
              <h5 className="modal-title pl-2" id="exampleModalLongTitle">
                Add More Tranche<span></span>
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body mt-15-px">
              <div className="container">
                <div className="row">
                  <div className="col-md-3 left-align">
                    <span className="fund-amount-cur">
                      &#8377;
                      <span className="fund-amount-label-value">
                        {' '}
                        {/* {total_grand_approved} */}
                        {total_grand_approved_amount != null
                          ? changeNumberFormat(Number(total_grand_approved_amount), 2, 1)
                          : 0}{' '}
                      </span>

                    </span>
                    <br />
                    <span className="fund-amount-label">
                      Total Grant Approved
                    </span>
                  </div>

                  <div className="col-md-3 left-align">
                    <span className="fund-amount-cur">
                      <span className="fund-amount-label-value">
                        {trancheData.length}{' '}
                      </span>
                    </span>
                    <br />
                    <span className="fund-amount-label">
                      Total No. of Tranches
                    </span>
                  </div>

                  <div className="col-md-4 right">
                    <br />
                    {/* <a
                      className="incubator-details-link"
                      onClick={() => setIsAddTrancheRowVisible(true)}
                    >
                      +Add More Tranches{' '}
                    </a> */}
                  </div>
                </div>

                <div className="row">
                  <div className="table-scroll ">
                    <table id="example">
                      <thead>
                        <tr>
                          <th className="text-left custom-td-left table-heading">
                            Tranche Request
                          </th>
                          <th className="text-left custom-td-left table-heading">
                            Amount Approved
                          </th>
                          <th className="text-left table-heading">
                            Amount Disbursed
                          </th>
                          <th className="text-left table-heading"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {isAddTrancheRowVisible == true ? (
                          <tr>
                            <td className="text-left ">
                              <span className="fund-amount-label">
                                {' '}
                                Tranche {trancheData.length + 1}
                              </span>
                            </td>
                            <td className="text-left custom-td-left">
                              <input
                                type="input"
                                placeholder="Enter"
                                name="amount_approved"
                                className="form-control input-height"
                                onChange={handleChange}
                                value={addMoreTrancheData.amount_approved}
                              />
                            </td>
                            <td className="text-left custom-td-left"></td>
                            <td className="text-center">
                              <a
                                className="incubator-details-link"
                                href="#"
                                onClick={() => addMoreTranche()}
                              >
                                Save
                              </a>
                              |
                              <a
                                className="incubator-details-link"
                                href=""
                                onClick={() => cancel()}
                                data-dismiss="modal"
                              >
                                Cancel
                              </a>
                            </td>
                          </tr>
                        ) : (
                          ''
                        )}
{/* {console.log(trancheData,"trancheData")} */}
                        {trancheData != undefined && trancheData.length > 0
                          ? trancheData.map((item: any,index:number) => (
                            <tr>
                              <td className="text-left ">
                                <span className="incubator-label-value">
                                  {item.tranche_number}
                                </span>
                                <br />
                                <span className="incubator-label">
                                  {' '}
                                  {item.tranche_requested_date != null ? formatDate(item.tranche_requested_date) : "-"}
                                </span>
                              </td>
                              <td className="text-left ">
                                <span className="incubator-label-value">
                                  {/* {' '}
                                  {changeNumberFormat(Number(item.approved_amount), 2, 1)} */}
                                  <input type="text" 
                                    style={{border:'none',width:'50%'}}
                                    name="item.approved_amount"
                                    value={changeNumberFormat(Number(item.approved_amount), 2, 1)}
                                    // onChange={(e) => handleInputChange(e, index)}
                                    // disabled={!isEditing}
                                  />
                                </span>
                                <br />
                                {item.approved_amount != null ? (
                                  <span className="incubator-label">
                                    {' '}
                                    {item.approved_amount_date != null ? formatDate(item.approved_amount_date) : "-"}
                                  </span>
                                ) : (
                                  ''
                                )}
                              </td>
                              <td className="text-left ">
                                <span className="incubator-label-value">
                                  {/* {' '}
                                  {changeNumberFormat(Number(item.fund_released), 2, 1)} */}
                                  <input type="text" 
                                    name="item.fund_released"
                                    style={{border:'none',width:'50%',}}
                                    value={changeNumberFormat(Number(item.fund_released), 2, 1)}
                                    // onChange={(e) => handleInputChange(e, index)}
                                    // disabled={!isEditing}
                                    
                                  />
                                </span>
                                <br />
                                {item.fund_released != null ? (
                                  <span className="incubator-label">
                                    {' '}
                                    {item.date_of_release != null ? formatDate(item.date_of_release) : "-"}
                                  </span>
                                ) : (
                                  ''
                                )}
                              </td>
                              <td className="text-center custom-td-left">

                                  {/* <a
                                    className="incubator-details-link"
                                    onClick={() => setIsEditing(!isEditing)}
                                    
                                  >
                                    Edit
                                  </a>
                                  |
                                  <a
                                    className="incubator-details-link"
                                    href="#"
                                    // onClick={() => addMoreTranche()}
                                    
                                  >
                                    Save
                                  </a> */}
                                    {/* <a
                                          className="incubator-details-link"
                                          href=""
                                          onClick={() =>
                                            handleRowChange(item.application_id)
                                          }
                                          data-dismiss="modal"
                                        >
                                          View
                                        </a> */}
                              </td>
                            </tr>
                          ))
                          : ''}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row pt-3 mb-3">
                <div className="col-md-12 centerText">
                  <button
                    className="tertiary  btn-yellow-primary"
                    data-dismiss="modal"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* //View Bank Details */}

      <div
        className="modal fade"
        id="viewBankDetails"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header modal-header-border-none ml-18px">
              <h5 className="modal-title pl-2" id="exampleModalLongTitle">
                View Bank Details<span></span>
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body text-left">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <span className="incubator-label-value">Account Holder</span>
                  </div>
                </div>

                <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">Account Name </span>
                  </div>
                  <div className="col-md-6 left">
                    <span className="incubator-label">Proof of PFMS Registration</span>
                  </div>
                </div>
{/* {console.log(accountDetailsData.bank_account_holder_name,"accountDetailsData")} */}
                <div className="row ">
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData.bank_account_holder_name == '' ||
                        accountDetailsData.bank_account_holder_name == null
                        ? '-'
                        : accountDetailsData.bank_account_holder_name}
                    </span>
                  </div>
                  <div className="col-md-6 left">
                    {/* {console.log(accountDetailsData.pan_card,"Sri@@@@@@@2")} */}
                    
                    {accountDetailsData.pan_card != undefined && accountDetailsData.pan_card != null ? 
                    
                      <div className="row">
                        <div className="col-md-3">
                                                  {getFileDetails(
                            accountDetailsData.pan_card,
                            'ext'
                          ) == 'pdf' ? (
                            <img src={pdf} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData.pan_card,
                            'ext'
                          ) == 'doc' ? (
                            <img src={doc} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData.pan_card,
                            'ext'
                          ) == 'xls' ? (
                            <img src={xls} alt="SISFS Logo" />
                          ) 
                          : (
                            <img src={Allround} alt="SISFS Logo" />
                          )
                          }
                        </div>
                        <div className="col-md-9">
                          <span className="document-label-value">
                            {getFileDetails(
                              accountDetailsData.pan_card_name,
                              'name'
                            )}
                          </span>
                          <br />
                          <br />
                          {/* {console.log(`${NODE_URL}`+ '/' + accountDetailsData.pan_card)} */}
                          <a
                            // href={getFileDetails(accountDetailsData.pan_card_name, "file")}
                            href={`${NODE_URL}`+ accountDetailsData.pan_card}
                            target="_blank"
                            //download="pan_card"
                            className="incubator-details-link"
                          >
                            View
                          </a>
                          {/* /
                          <a
                            href="#"
                            //download="pan_card"
                            className="incubator-details-link"
                            onClick={() =>
                              downloadDocument(
                                accountDetailsData.pan_card,
                                accountDetailsData.pan_card_name
                              )
                            }
                          >
                            Download
                          </a> */}
                        </div>
                      </div>
                      : ""}
                  </div>
                </div>

                 <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">
                      Proof of TRA Account & ECS Mandate Form
                    </span>
                    <br />
                   {accountDetailsData.cancelled_cheque_location != undefined && accountDetailsData.cancelled_cheque_location != null ?
                      <div className="row">
                        <div className="col-md-3">
                          {getFileDetails(
                            accountDetailsData.cancelled_cheque_location,
                            'ext'
                          ) == 'pdf' ? (
                            <img src={pdf} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData.cancelled_cheque_location,
                            'ext'
                          ) == 'doc' ? (
                            <img src={doc} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData.cancelled_cheque_location,
                            'ext'
                          ) == 'xls' ? (
                            <img src={xls} alt="SISFS Logo" />
                          ) : (
                            <img src={Allround} alt="SISFS Logo" />
                          )}
                        </div>
                        <div className="col-md-9">
                          <span className="document-label-value">
                            {getFileDetails(
                              accountDetailsData.cancelled_cheque_name,
                              'name'
                            )}
                          </span>
                          <br />
                          <br />
                          {/* {console.log(`${NODE_URL}`+ '/' + accountDetailsData.cancelled_cheque_location)} */}

                          <a
                            // href={getFileDetails(accountDetailsData.cancelled_cheque_location, "file")}
                            href={`${NODE_URL}`+  '/' + accountDetailsData.cancelled_cheque_location}

                            target="_blank"
                            //download="proof_of_disbursement"
                            className="incubator-details-link"
                          >
                            View
                          </a>
                          {/* /
                          <a
                            href="#"
                            //download="proof_of_disbursement"
                            className="incubator-details-link"
                            onClick={() =>
                              downloadDocument(
                                accountDetailsData.cancelled_cheque_location,
                                accountDetailsData.cancelled_cheque_name
                              )
                            }
                          >
                            Download
                          </a> */}
                        </div>
                      </div>
                      : ""} 

{accountDetailsData.darpan_location != undefined && accountDetailsData.darpan_location != null ?
                      <div className="row">
                        <div className="col-md-3">
                          {getFileDetails(
                            accountDetailsData.darpan_location,
                            'ext'
                          ) == 'pdf' ? (
                            <img src={pdf} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData.darpan_location,
                            'ext'
                          ) == 'doc' ? (
                            <img src={doc} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData.darpan_location,
                            'ext'
                          ) == 'xls' ? (
                            <img src={xls} alt="SISFS Logo" />
                          ) : (
                            <img src={Allround} alt="SISFS Logo" />
                          )}
                        </div>
                        <div className="col-md-9">
                          <span className="document-label-value">
                            {getFileDetails(
                              accountDetailsData.darpan_name,
                              'name'
                            )}
                          </span>
                          <br />
                          <br />
                          <a
                            // href={getFileDetails(accountDetailsData.darpan_location, "file")}
                            href={`${NODE_URL}`+ '/' + accountDetailsData.darpan_location}
                            target="_blank"
                            //download="proof_of_disbursement"
                            className="incubator-details-link"
                          >
                            View
                          </a>
                          {/* /
                          <a
                            href="#"
                            //download="proof_of_disbursement"
                            className="incubator-details-link"
                            onClick={() =>
                              downloadDocument(
                                accountDetailsData.darpan_location,
                                accountDetailsData.darpan_name
                              )
                            }
                          >
                            Download
                          </a> */}
                        </div>
                      </div>
                      : ""} 
                  </div>
                  <div className="col-md-4"></div>
                </div> 
                <div className="application-incubator-hr">

                  <hr />
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <span className="incubator-label-value">Account Details</span>
                  </div>
                </div>

                <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">Bank Name</span>
                  </div>
                  <div className="col-md-4">
                    <span className="incubator-label">Account Number</span>
                  </div>
                </div>

                <div className="row ">
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData.bank_name == '' ||
                        accountDetailsData.bank_name == null
                        ? '-'
                        : accountDetailsData.bank_name}
                    </span>
                  </div>
                  <div className="col-md-6">
                    <span className="incubator-label-value">
                      {accountDetailsData.account_number == '0' ||
                        accountDetailsData.account_number == null
                        ? '-'
                        : accountDetailsData.account_number}
                    </span>
                  </div>
                </div>

                <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">Account Type</span>
                  </div>
                  <div className="col-md-6 left">
                    <span className="incubator-label">
                      Branch Name/Branch Code
                    </span>
                  </div>
                </div>

                <div className="row ">
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData.account_type == 0 ||
                        accountDetailsData.account_type == null
                        ? '-'
                        : accountDetailsData.account_type}
                    </span>
                  </div>
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData.branch_name == '' ||
                        accountDetailsData.branch_name == null
                        ? '-'
                        : accountDetailsData.branch_name}
                    </span>
                  </div>
                </div>

                <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">IFSC Code</span>
                  </div>
                  <div className="col-md-6 left">
                    <span className="incubator-label">MICR Code</span>
                  </div>
                </div>

                <div className="row ">
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData.bank_ifsc_code == '' ||
                        accountDetailsData.bank_ifsc_code == null
                        ? '-'
                        : accountDetailsData.bank_ifsc_code}
                    </span>
                  </div>
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData.bank_micr_code == '' ||
                        accountDetailsData.bank_micr_code == null
                        ? '-'
                        : accountDetailsData.bank_micr_code}
                    </span>
                  </div>
                </div>

                <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">Bank Address</span>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData.branch_address == '' ||
                        accountDetailsData.branch_address == null
                        ? '-'
                        : accountDetailsData.branch_address}
                    </span>
                  </div>
                </div>
              </div>
              <div className="row pt-3 mb-3">
                <div className="col-md-12 centerText">
                  <button
                    className="tertiary  btn-yellow-primary"
                    data-dismiss="modal"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showEditSuccessModal && (
        <>
          <div className="modal-backdrop fade show"></div>

          <div
            className="modal align-middle modal-sisfs d-block"
            id="FormSubmissionSuccess"
          >
            <div className="modal-dialog modal-dialog-centered modal-md">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <i className="fa fa-check-circle-o"></i>
                  <h3 className="modal-message">Thank You !</h3>
                  <div className="modal-text">
                    Tranche Details Updated Successfully !!
                  </div>
                  <div className="modal-action">
                    <button
                      className="btn btn-sisfs btn-yellow-primary"
                      onClick={dismissModal}
                    >
                      Ok !!
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {showEditFailureModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div
            className="modal align-middle modal-sisfs d-block"
            id="FormSubmissionError"
          >
            <div className="modal-dialog modal-dialog-centered modal-md">
              <div className="modal-content">
                <div className="modal-body text-center">
                  {/* <i className="fa fa-times-circle-o"></i> */}
                  <h3 className="modal-message message-orange">
                    Oops! Something is Wrong
                  </h3>
                  <br />
                  <h3 className="modal-message message-orange">
                    Please Try Again !!!
                  </h3>
                  <div className="modal-action">
                    <button
                      className="btn btn-sisfs btn-yellow-primary"
                      onClick={dismissModal}
                    >
                      OK !
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
export default IncubatorFundDetailsReapplyComponent;
